import React from 'react';

import Notification from '../Notification/index.troy';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '12px 0'
  }
}));

const NotificationList = ({ notifications, authToken, internal }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      {notifications && notifications.length
        ? notifications.map(
            (
              { type, text, datetime, mainDoc, docs, subject, channel, name },
              idx
            ) => (
              <Notification
                {...{
                  type,
                  text,
                  datetime,
                  mainDoc,
                  docs,
                  subject,
                  channel,
                  name,
                  authToken
                }}
                key={idx}
              />
            )
          )
        : null}
    </div>
  );
};

export default NotificationList;
